"use client";
import "../../chunk-MMUBH76A.js";
import { jsx } from "react/jsx-runtime";
import { createContext, useMemo } from "react";
const defaultCosmosExternalWallet = {
  wallets: [],
  chains: [],
  chainId: void 0,
  disconnect: () => Promise.resolve(),
  switchChain: () => Promise.resolve({}),
  signMessage: () => Promise.resolve({}),
  signVerificationMessage: () => Promise.resolve({})
};
const CosmosExternalWalletContext = createContext(defaultCosmosExternalWallet);
function CosmosExternalWalletProvider({ children }) {
  const wallets = [];
  const chains = [];
  const chainId = void 0;
  const disconnect = () => Promise.resolve();
  const switchChain = () => Promise.resolve({});
  const signMessage = () => Promise.resolve({});
  const signVerificationMessage = () => Promise.resolve({});
  return /* @__PURE__ */ jsx(
    CosmosExternalWalletContext.Provider,
    {
      value: useMemo(
        () => ({ wallets, chains, chainId, disconnect, switchChain, signMessage, signVerificationMessage }),
        [wallets, chains, chainId, disconnect, switchChain, signMessage, signVerificationMessage]
      ),
      children
    }
  );
}
export {
  CosmosExternalWalletContext,
  CosmosExternalWalletProvider,
  defaultCosmosExternalWallet
};
